import {useMutation, useQueryClient} from '@tanstack/react-query';
import partnershipAdsUpdaters, {
  CreatePartnershipAdParams,
} from '@/api/updaters/partnershipAds';
import {PartnershipAdFormData} from '@/components/partnership-ads-modal/partnership-ad-form/PartnershipAdForm';

interface UseCreatePartnershipAdMutationParams {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

function useCreatePartnershipAdMutation({
  onSuccess,
  onError,
}: UseCreatePartnershipAdMutationParams = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      brandId,
      swapMatchId,
      formData,
    }: {
      brandId: string;
      swapMatchId: string;
      formData: PartnershipAdFormData;
    }) => {
      const params: CreatePartnershipAdParams = {
        brandId,
        swapMatchId,
        budget: {
          type: formData.budgetType,
          amount: formData.budgetAmount,
        },
        schedule: {
          startDate: formData.startDate,
          endDate: formData.endDate || undefined,
        },
        audience: {
          ageMin: formData.ageMin,
          ageMax: formData.ageMax,
          genders: formData.genders,
          locations: formData.locations,
        },
      };

      return partnershipAdsUpdaters.createPartnershipAd(params);
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: Error) => {
      if (onError) {
        onError(error);
      }
    },
  });
}

export default useCreatePartnershipAdMutation;
